var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 8.375C3 5.09461 5.60656 2.75 9 2.75C12.3934 2.75 15 5.09461 15 8.375C15 11.0745 13.8031 13.0435 12.4219 14.3511C11.7284 15.0076 10.9937 15.4915 10.3544 15.8084C9.69032 16.1375 9.20427 16.2499 9 16.2499C8.79573 16.2499 8.30968 16.1375 7.64558 15.8084C7.00629 15.4915 6.27156 15.0076 5.57813 14.3511C4.1969 13.0435 3 11.0745 3 8.375ZM9 1.25C4.89344 1.25 1.5 4.15539 1.5 8.375C1.5 11.5644 2.9281 13.9078 4.54687 15.4404C5.35344 16.204 6.21246 16.7722 6.97942 17.1523C7.72157 17.5202 8.45427 17.7499 9 17.7499C9.54573 17.7499 10.2784 17.5202 11.0206 17.1523C11.7875 16.7722 12.6466 16.204 13.4531 15.4404C15.0719 13.9078 16.5 11.5644 16.5 8.375C16.5 4.15539 13.1066 1.25 9 1.25ZM7.5 8.75C7.5 7.92157 8.17157 7.25 9 7.25C9.82843 7.25 10.5 7.92157 10.5 8.75C10.5 9.57843 9.82843 10.25 9 10.25C8.17157 10.25 7.5 9.57843 7.5 8.75ZM9 5.75C7.34315 5.75 6 7.09315 6 8.75C6 10.4069 7.34315 11.75 9 11.75C10.6569 11.75 12 10.4069 12 8.75C12 7.09315 10.6569 5.75 9 5.75Z",
    fill: "#4E4E4E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.fd59d8644796bfe906162d1dc7d2ea5a.svg";
export { ForwardRef as ReactComponent };